import { render, staticRenderFns } from "./Oxford1.vue?vue&type=template&id=c260d5f2"
import script from "./Oxford1.vue?vue&type=script&lang=js"
export * from "./Oxford1.vue?vue&type=script&lang=js"
import style0 from "./Oxford1.vue?vue&type=style&index=0&id=c260d5f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports